<div [attr.id]="id" [style.width.%]="100" [style.height.px]="height"></div>